import React, { useEffect, useRef } from 'react';
import { useNotification } from '../contexts/NotificationContext';
import './ConfirmModal.css';

const ConfirmModal = () => {
  const { modal } = useNotification();
  const modalRef = useRef(null);

  useEffect(() => {
    if (modal) {
      // Focus trap
      const focusableElements = modalRef.current?.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (focusableElements && focusableElements.length > 0) {
        focusableElements[0].focus();
      }

      // Escape key handler
      const handleEscape = (e) => {
        if (e.key === 'Escape') {
          modal.onCancel?.();
        }
      };

      document.addEventListener('keydown', handleEscape);
      return () => document.removeEventListener('keydown', handleEscape);
    }
  }, [modal]);

  if (!modal) return null;

  const {
    title,
    body,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    type = 'warning',
    onConfirm,
    onCancel
  } = modal;

  const getIcon = () => {
    switch (type) {
      case 'danger':
        return (
          <svg className="modal-icon modal-icon-danger" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        );
      case 'warning':
        return (
          <svg className="modal-icon modal-icon-warning" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        );
      case 'info':
        return (
          <svg className="modal-icon modal-icon-info" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="confirm-modal-overlay" onClick={onCancel}>
      <div 
        className="confirm-modal" 
        ref={modalRef}
        onClick={(e) => e.stopPropagation()}
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <div className="confirm-modal-header">
          {getIcon()}
          <h2 id="modal-title" className="confirm-modal-title">{title}</h2>
        </div>
        
        <div id="modal-description" className="confirm-modal-body">
          {body}
        </div>
        
        <div className="confirm-modal-actions">
          <button 
            className="confirm-modal-button confirm-modal-button-secondary"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button 
            className={`confirm-modal-button confirm-modal-button-primary confirm-modal-button-${type}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;

